import React from 'react';

const Section3 = ({ imgWebp, imgJpg, videoSrc, imgAlt, title, subtitle, desc }) => {
  return (
    <section className="section-3">

      <div className='container'>
        <div className='container-box text-center'>
            <h3 className='title'>Pure Water Solutions for your home and health</h3>
            <p className='desc'>Transform your home with our advanced whole home water filtration systems for cleaner, healthier living.</p>
        </div>
        <div className='other-row content'>
            <div className='col col-30'>
                <h3 className='title'>Chlorine Free</h3>
                <p className='desc'>By removing chlorine and other disinfectants from your water, our systems provide a gentler, safer option for sensitive skin and hair. Enjoy bathing and showering without the harsh effects of chlorine exposure.</p>
            </div>
            <div className='col col-70'>
                <div className='other-row'>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-hand-water-icon.png" />
                            <img src="/img/blue-hand-water-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Hydrated Skin</h4>
                        <p className="desc">Clean water is essential for maintaining soft, hydrated skin. By removing impurities, our filtration systems help your skin retain moisture, leaving it healthier and more resilient over time.</p>
                    </div>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-lady-icon.png" />
                            <img src="/img/blue-lady-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Better Hair</h4>
                        <p className="desc">Filtered water free of chlorine and harsh minerals helps maintain the natural oils in your hair, reducing dryness and frizz. It's an ideal choice for those looking to improve the shine, strength, and overall quality of their hair.</p>                        
                    </div>
                </div>
                <div className='other-row'>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-nose-icon.png" />
                            <img src="/img/blue-nose-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Better Taste and Smell</h4>
                        <p className="desc">Say goodbye to unpleasant odours and chemical tastes in your water. Our advanced filtration systems ensure that every sip is refreshing, pure, and free from any unwanted aftertaste, making your water more enjoyable for drinking, cooking, and everyday use.</p>                        
                    </div>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-leaf-icon.png" />
                            <img src="/img/blue-leaf-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Eco-Friendly Solution for
                        Sustainable Living</h4>
                        <p className="desc">Reduce plastic waste and enjoy fresh water daily.</p>                        
                    </div>
                </div>
                <div className='other-row'>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-virus-icon.png" />
                            <img src="/img/blue-virus-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Removes Bad Bacteria</h4>
                        <p className="desc">Our filtration systems effectively remove harmful bacteria and pathogens, providing peace of mind that your water is safe for all household uses. By filtering out microbial contaminants, we help safeguard your family from waterborne illnesses.</p>                        
                    </div>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-suit-icon.png" />
                            <img src="/img/blue-suit-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Softer Clothing</h4>
                        <p className="desc">Washing clothes in filtered water helps maintain fabric softness by reducing exposure to harsh minerals and chlorine. Your clothing stays softer, brighter, and in better condition over time, with fewer residues and less wear.</p>                        
                    </div>
                </div>
                <div className='other-row'>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-no-chemical-icon.png" />
                            <img src="/img/blue-no-chemical-icon.png" alt="Responsive" />
                        </picture>
                        <h4>No Heavy Metals and
                        Fluoride</h4>
                        <p className="desc">By removing heavy metals like lead and contaminants like fluoride, our systems protect against the long-term health effects of these substances. Clean, toxin-free water helps reduce risks associated with heavy metal exposure, including neurological and developmental issues.</p>                        
                    </div>
                    <div className='col col-50'>
                        <picture>
                            <source type="image/png" srcSet="/img/blue-glass-water-icon.png" />
                            <img src="/img/blue-glass-water-icon.png" alt="Responsive" />
                        </picture>
                        <h4>Health Benefits</h4>
                        <p className="desc">Our water filtration systems remove harmful contaminants, providing clean, safe water that supports overall health and wellness. With fewer pollutants, you'll experience a healthier environment for drinking, cooking, and bathing, leading to improved immunity and vitality.</p>                        
                    </div>
                </div>
            </div>
        </div>
      </div>

    </section>
  )
}

export default Section3;